/*
 * @Author: zxf
 * @Date: 2022-07-20 14:20:09
 * @LastEditors: DQL
 * @LastEditTime: 2023-04-25 16:57:47
 * @Description: 消防会议管理路由
 */

const hyglRoutes = {
  path: 'hygl',
  name: 'xfjchygl',
  component: { template: '<router-view></router-view>' },
  children: [
    {
      path: 'hyglIndex',
      name: 'xfjchyglIndex',
      component: () => import(/* webpackChunkName: "hyglIndex" */ '@/features/xfjcgl/hygl/index.vue'),
      meta: {
        navtabTitle: '检测会议管理',
        isCache: true,
        ignoreDiff: [],
        menuElements: []
      }
    },
    {
      path: 'add',
      name: 'addHygl',
      component: () => import(/* webpackChunkName: "addHygl" */'@/features/xfjcgl/hygl/add.vue'),
      meta: {
        navtabTitle: '检测会议新增',
        isCache: true,
        ignoreDiff: [],
        menuElements: []
      }
    },
    {
      path: 'edit/:xmId',
      name: 'editHygl',
      component: () => import(/* webpackChunkName: "editHygl" */'@/features/xfjcgl/hygl/edit.vue'),
      meta: {
        navtabTitle: '检测会议编辑',
        isCache: true,
        ignoreDiff: [],
        menuElements: []
      }
    }
  ]
};

export default hyglRoutes;
